import request from '../request'
const queryPage = data => request({
  url: '/expertBook/queryPage',
  data,
  method: 'POST'
})
const insert = data => request({
  url: '/expertBook/insert',
  data,
  method: 'POST'
})
const deleteByRowIds = params => request({
  url: '/expertBook/delete',
  params
})
const queryDetailByRowId = params => request({
  url: '/expertBook/queryDetailByRowId',
  params
})
const update = data => request({
  url: '/expertBook/update',
  data,
  method: 'POST'
})
const leaveMessageList = data => request({
  url: '/leaveMessage/queryPage',
  data,
  method: 'POST'
})
const leaveMessageDel = params => request({
  url: '/leaveMessage/delete',
  params
})
export default {
  queryPage,
  insert,
  deleteByRowIds,
  queryDetailByRowId,
  update,
  leaveMessageList,
  leaveMessageDel
}